<div
  class="d-flex user-container align-items-center size-limit"
  [class.table-size-limit]="hasTableSizeLimit"
  [class.connection-size-limit]="hasConnectionSizeLimit"
>
  <app-small-profile-image
    [profileImage]="user.image_url"
    [accountStatus]="user.account_status"
    [dataTestId]="'user-avatar-' + srtIndex"
    [accessForAdmin]="accessForAdmin"
    [link]="getLink"
  ></app-small-profile-image>
  <div class="name-position ms-2">
    <h5 class="my-0">
      <app-profile-link
        [dataTestId]="'username-' + srtIndex"
        [cssStyles]="'username'"
        [status]="getStatus"
        [userId]="user.user_id"
        [text]="user.displayed_name"
        [isHideStatus]="accessForAdmin"
      ></app-profile-link>
    </h5>
    <ng-content></ng-content>
  </div>
</div>
